module.exports = __webpack_public_path__ + "img/iriomote_14.7b4627f1.jpg";